import React, { useContext, useEffect, useState } from 'react';
import { Link, useLoaderData } from 'react-router-dom';
import { AuthContext } from '../../../contexts/AuthProvider/AuthProvider';
import useTitle from '../../../hooks/useTitle';
import logo from '../../../assets/avatar.jpg';

const ServiceDetailsAndReview = () => {

    useTitle('Service Details and Reviews');

    const { _id, img, title, price, description } = useLoaderData();

    const { user } = useContext(AuthContext);

    const [allReviews, setAllReviews] = useState([]);

    useEffect(() => {
        fetch(`https://mommy-cloud-kitchen-server.vercel.app/reviews/${_id}`)
            .then(res => res.json())
            .then(data => {
                console.log(data);
                setAllReviews(data);
            }
            )
    }, [_id])


    return (
        <div>
            <div className="card lg:w-1/2 bg-base-100 shadow-xl mx-auto mb-20">
                <h2 className='text-4xl text-center mb-6 font-bold'>Service <span className='text-orange-600'>Details</span> </h2>
                <figure><img src={img} alt="" className='h-72' /></figure>
                <div className="card-body">
                    <h2 className="card-title">{title}</h2>
                    <p>{description}</p>
                    <p className='font-bold mt-6'>Price: <b><span className='text-orange-600'>${price}</span></b></p>
                    <Link to={`/addreviews/${_id}`} className="card-actions justify-end">
                        <button className="btn btn-primary">Add Review</button>
                    </Link>
                </div>
            </div>

            <h3 className="font-semibold mb-6 px-20 text-4xl text-center">All <span className='text-primary'>Reviews</span> </h3>
            <div className="overflow-x-auto lg:w-2/3 mx-auto shadow-xl mb-12">
                {
                    allReviews.length > 0 ?
                        <table className="table w-full">
                            <tbody>
                                {
                                    allReviews.map((review, i) => {

                                        return <tr className='' key={i}>
                                            <td className=''>
                                                {

                                                    review?.photoURL !== "" ?
                                                        <>
                                                            <div className="avatar">
                                                                <div className="w-14 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                                                                    <img src={review.photoURL} alt="user img" />
                                                                </div>
                                                            </div>
                                                        </>
                                                        :
                                                        <>
                                                            <div className="avatar">
                                                                <div className="w-14  rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                                                                    <img src={logo} alt="avatar" />
                                                                </div>
                                                            </div>
                                                        </>
                                                }

                                            </td>

                                            <td className='ms-0'>Name: {review?.customer}</td>
                                            <td>Review: {review?.message}</td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                        :
                        <p className="text-center text-6xl mb-12"><b>No reviews yet</b></p>
                }
            </div>
        </div>
    );
};

export default ServiceDetailsAndReview;